import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from "@material-ui/pickers";
import CalendarToday from '@material-ui/icons/CalendarToday';

import { Moment } from 'moment';

import pickUpDateStyles from './pickUpDate.module.css';

const styles = (theme: Theme) =>

  createStyles({
    input: {
      color: 'var(--primaryblue)',
      fontSize: '14px',
      width: '140px',
      marginRight: '20px'
    }
  });

interface PickUpDateProps {
  classes: any;
  titleText?: string;
  pickUpDate: Moment;
  minDate?: Date;
  handleChange: (date: Moment) => void;
};

const pickUpDate = (props: PickUpDateProps)=> {

  const { classes } = props;

  return (
    <div className={ pickUpDateStyles.pickUpWrapper }>
      { props.titleText && <span className={ pickUpDateStyles.title } >{ props.titleText }</span> }
      <KeyboardDatePicker
        format='MMMM DD, YYYY'
        minDate={props.minDate}
        value={ props.pickUpDate }
        onChange={ (date: any) => props.handleChange(date) }
        InputProps={{ className: classes.input }}
        autoOk
      />
    </div>
  );
};

export default withStyles(styles)(pickUpDate);